import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import {
  getRunCenterQueryKey,
  listRunCenterRuns,
  type ListRunCenterFilters,
  type RunCenterPage,
} from '../api/run-center.client.js';

/** Poll interval keeping the journal fresh while the worker changes statuses. */
export const RUN_CENTER_REFETCH_INTERVAL_MS = 15_000;

export function useRunCenter(filters: ListRunCenterFilters = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery<RunCenterPage>({
    queryKey: getRunCenterQueryKey(workspaceId, filters),
    queryFn: () => listRunCenterRuns(filters),
    enabled: scope !== null,
    // The worker flips run statuses in the background; polling shows those
    // transitions without a page reload.
    refetchInterval: RUN_CENTER_REFETCH_INTERVAL_MS,
    // Keep the previous list visible (slightly dimmed) while filters change,
    // so switching scenario/status does not flash an empty loading state.
    placeholderData: keepPreviousData,
  });
}
